// src/modules/app-views/leads/service.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import axiosService from 'services/axiosService';
import { API } from 'constants/Api';
import apiConfig from 'configs/fetchInterceptor';
import { getStorageAuthItem } from 'stores/auth';

// *******************************************************************************
// SERVICE METHODS
// *******************************************************************************

const getModuleParameters = () => null;

const assignLead = async (_id, data) => {
  const url = API.LEADS.ASSIGN.replace(':_id', _id);
  const [response] = await axiosService.put({ url, data });
  return response;
};

const purchaseLead = async _id => {
  const url = API.LEADS.PURCHASE.replace(':_id', _id);
  const [response] = await axiosService.put({ url });
  return response;
};

const discardLead = async (_id, reason) => {
  const url = API.LEADS.DISCARD.replace(':_id', _id);
  const [response] = await axiosService.put({ url, data: { reason } });
  return response;
};

// Archive a lead after CRM distribution
// Sets _metadata.audit.filedAt + filedByAccountId (accountId extracted from headers by backend)
const archiveLead = async _id => {
  const url = API.LEADS.FILE.replace(':_id', _id);
  const [response] = await axiosService.put({ url });
  return response;
};

// Start a bulk import job. Returns { jobId, total } after backend enqueues.
const startBulkImport = async ({ leads, conflictStrategy }) => {
  const [response] = await axiosService.post({
    url: API.LEADS.BULK_IMPORT,
    data: { leads, conflictStrategy },
    returnAsObject: true,
  });
  return response;
};

// Subscribe to SSE progress events for a given jobId.
// Returns a teardown function that closes the EventSource.
const subscribeToImportProgress = (jobId, onEvent) => {
  const url = API.LEADS.BULK_IMPORT_EVENTS.replace(':jobId', jobId);
  const baseURL = apiConfig.defaults.baseURL || '';
  const token = getStorageAuthItem('token');
  const fullUrl = `${baseURL}${url}${token ? `?token=${encodeURIComponent(token)}` : ''}`;
  const eventSource = new EventSource(fullUrl);

  const handler = ev => {
    try {
      const payload = JSON.parse(ev.data);
      onEvent({ type: ev.type, data: payload });
    } catch (error) {
      console.error('[leadsService] SSE parse error:', JSON.stringify({ message: error?.message }, null, 2));
    }
  };

  ['progress', 'done', 'error'].forEach(type => eventSource.addEventListener(type, handler));

  eventSource.onerror = () => {
    console.error('[leadsService] SSE connection error:', JSON.stringify({ readyState: eventSource.readyState }, null, 2));
  };

  return () => eventSource.close();
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
const leadsService = {
  getModuleParameters,
  assignLead,
  purchaseLead,
  discardLead,
  archiveLead,
  startBulkImport,
  subscribeToImportProgress,
};

export default leadsService;
